import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkflowService } from 'api/services';
import { useInfiniteQuery } from 'react-query';
import { Site } from 'shared/hooks';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';

export const useGetWorkflowListing = (site: Site) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workflowsListing(),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedWorkflowService.getWorkflowsListing(site, {
        page: pageParam,
        size: DEFAULT_PAGE_SIZE,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
